import { useQuery } from '@tanstack/react-query';
import { auditLogApi } from '../api/auditLogApi';

/**
 * GET /api/eraf/audit-logs/actions — 액션 카탈로그 (ROLE_ADMIN)
 * queryKey: ['audit-log', 'actions']
 */
export function useAuditActions() {
  return useQuery({
    queryKey: ['audit-log', 'actions'],
    queryFn: () => auditLogApi.actions(),
    staleTime: 5 * 60_000,
  });
}
